export default __webpack_public_path__ + "assets/locationNearby.25c7ad31.svg";